var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('page-navigation');
import { breakpoints, theme } from '@shapeable/theme';
import { IconLink } from './icon-link';
import { useLink } from '../hooks/use-link';
import { useLinearNavigation } from '../hooks/use-linear-navigation';
import { useMenu } from '../hooks/use-menu';
import { filter } from 'lodash';
import { SlimSelect } from './slim-select';
import { useEntity } from '../hooks/use-entity';
import { ChevronLeftIconGlyph, ChevronRightIconGlyph } from '@shapeable/icons';
import { useEnv } from '../hooks/use-env';
export var LinearNavigationDefaultProps = {
  showButtons: true,
  borderless: false,
  variant: 'legacy',
  isSearchable: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    a {\n      text-decoration: none;\n    }\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    width: 300px;\n  "], ["\n    display: flex;\n    width: 300px;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 400px;\n  "], ["\n    width: 400px;\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 20px;\n    align-items: center;\n    font-size: ", ";\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n  "], ["\n    height: 20px;\n    align-items: center;\n    font-size: ", ";\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n  "])), theme.FONT_SIZE(12)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 30px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  "], ["\n    height: 30px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  "])))
});
var NextButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    padding: 0 ", " 0 ", ";\n  "], ["\n    ", ";\n    padding: 0 ", " 0 ", ";\n  "])), LinkStyles, theme.UNIT(3), theme.UNIT(4)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.UNIT(3))
});
var PrevButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    border-right: 1px solid ", ";\n    padding: 0 ", " 0 ", ";\n  "], ["\n    ", ";\n    border-right: 1px solid ", ";\n    padding: 0 ", " 0 ", ";\n  "])), LinkStyles, theme.COLOR('line-mid'), theme.UNIT(4), theme.UNIT(3)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    border-right: none;\n    padding: 0 ", ";\n  "], ["\n    border-right: none;\n    padding: 0 ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(SlimSelect).attrs(cls.attr('select'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  PrevButton: styled(IconLink).attrs(cls.attr('prev-button'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PrevButtonStyles),
  NextButton: styled(IconLink).attrs(cls.attr('next-button'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NextButtonStyles)
};
export var LinearNavigation = function (props) {
  var className = props.className,
    value = props.value,
    showButtons = props.showButtons,
    variant = props.variant,
    borderless = props.borderless,
    isSearchable = props.isSearchable;
  var info = useLinearNavigation();
  var env = useEnv();
  var items = info.items,
    hasNext = info.hasNext,
    hasPrev = info.hasPrev,
    next = info.next,
    prev = info.prev;
  var selectedIndex = info.selectedIndex;
  // const activeEntity = useEntity();
  // const activePage = usePage();
  var entity = useEntity();
  // need to store the current react select search term, so we can add the current page below only if there is no active search term.
  var _a = __read(React.useState(''), 2),
    term = _a[0],
    setTerm = _a[1];
  var selectOptions = items.map(function (item) {
    var label = filter([item.outlineNumber, item.name]).join('. ');
    return {
      label: label,
      value: item.path,
      depth: item.depth
    };
  });
  // the value here needs to be the actual option object (could we abstract over this and look for the value??)
  // let selectedIndex = findIndex(selectOptions, option => option.value === value || option.value === entity.__path) || 0;
  // console.log(selectedIndex);
  if (selectedIndex === -1 && term === '' && entity && entity.name) {
    // if the page is not in the linear navigation, just append it to the end
    selectOptions.push({
      depth: 0,
      label: "".concat(entity.name),
      value: value
    });
    selectedIndex = selectOptions.length - 1;
  }
  var navigate = useLink().navigate;
  var selection = selectOptions[selectedIndex];
  var menu = useMenu();
  var onChange = function (option) {
    menu.hide();
    navigate(option.value);
  };
  var onInputChange = function (term) {
    setTerm(term);
  };
  if (env.DEBUG_PAGE_NAVIGATION) {
    console.log(prev, next, hasNext, hasPrev);
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showButtons && React.createElement(My.PrevButton, {
    icon: React.createElement(ChevronLeftIconGlyph, null),
    disabled: !hasPrev,
    href: prev && prev.path,
    title: "Previous Page"
  }), React.createElement(My.Select, {
    variant: variant,
    isSearchable: isSearchable,
    onInputChange: onInputChange,
    borderless: borderless,
    fontSize: 12,
    isClearable: false,
    onChange: onChange,
    value: selection,
    options: selectOptions
  }), showButtons && React.createElement(My.NextButton, {
    icon: React.createElement(ChevronRightIconGlyph, null),
    disabled: !hasNext,
    href: next && next.path,
    title: "Next Page"
  }));
};
LinearNavigation.defaultProps = LinearNavigationDefaultProps;
LinearNavigation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;